// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iM6bP","label":"styles_label__2wJel"};